export function CreateWidgetIcon() {
    return (
      <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
      className='neededFill'
        fill="#9197B3"
        d="M10 15.167H6C2.38 15.167.833 13.62.833 10V6C.833 2.38 2.38.833 6 .833h4c3.62 0 5.167 1.547 5.167 5.167v4c0 3.62-1.547 5.167-5.167 5.167zM6 1.833C2.927 1.833 1.833 2.927 1.833 6v4c0 3.073 1.094 4.167 4.167 4.167h4c3.073 0 4.167-1.094 4.167-4.167V6c0-3.073-1.094-4.167-4.167-4.167H6z"
      ></path>
      <path
      className='neededFill'
        fill="#9197B3"
        d="M8 8.72a.497.497 0 01-.253-.067l-3.533-2.04a.495.495 0 01-.18-.68c.14-.24.446-.32.68-.18l3.28 1.9 3.26-1.887a.498.498 0 01.68.18.505.505 0 01-.18.68L8.247 8.653A.525.525 0 018 8.72z"
      ></path>
      <path
      className='neededFill'
        fill="#9197B3"
        d="M8 12.347a.504.504 0 01-.5-.5V8.22c0-.273.227-.5.5-.5s.5.227.5.5v3.627c0 .273-.227.5-.5.5z"
      ></path>
      <path
      className='neededFill'
        fill="#9197B3"
        d="M8 12.5c-.387 0-.766-.087-1.073-.254L4.794 11.06c-.64-.354-1.134-1.2-1.134-1.933v-2.26c0-.727.5-1.574 1.133-1.934l2.134-1.186c.613-.34 1.533-.34 2.146 0l2.134 1.186c.64.354 1.133 1.2 1.133 1.934v2.26c0 .726-.5 1.573-1.133 1.933l-2.134 1.186c-.306.174-.686.254-1.073.254zm0-8c-.22 0-.433.04-.587.127L5.28 5.813c-.326.18-.62.687-.62 1.054v2.26c0 .373.294.873.62 1.053l2.133 1.187c.307.173.867.173 1.174 0l2.133-1.187c.327-.18.62-.687.62-1.053v-2.26c0-.374-.293-.874-.62-1.054L8.587 4.627C8.433 4.54 8.22 4.5 8 4.5z"
      ></path>
    </svg>
    );
  }